/* @flow */

import $ from 'jquery';
import VanillaToasts from 'vanillatoasts';
import fromSerialize from 'form-serialize';
import uploads from '../../empresa/uploads';
import MENSAGENS from '../../mensagens';
import applyLoading from '../../utils/apply-loading';
import xhr from '../../utils/xhr';
import getFileImagemInput from '../../utils/get-file-imagem-input';
import { type Cores } from '../../empresa/types';
import getElementoPorId from '../../utils/get-elemento-por-id';
import exibirErro from '../../utils/exibir-erro';
import proximaEtapa from './proximaEtapa';

let coresAnterior: Cores;


const getDadosFormularioCores = (): Cores => fromSerialize(document.forms.namedItem('formulario-aplicativo'), { hash: true });

$(() => {
    coresAnterior = getDadosFormularioCores();
});

const corMudou = (cores: Cores) => cores.primaria !== coresAnterior.primaria
    || cores.secundaria !== coresAnterior.secundaria
    || cores.terciaria !== coresAnterior.terciaria;

const mensagemSucesso = () => {
    VanillaToasts.create({
        title: MENSAGENS.EMPRESA.APLICATIVO.EDICAO.SUCESSO.TITULO,
        text: MENSAGENS.EMPRESA.APLICATIVO.EDICAO.SUCESSO.TEXTO,
        type: 'success',
        timeout: 5000,
    });
};

const mensagemNenhumaAlteracao = () => {
    VanillaToasts.create({
        title: MENSAGENS.EMPRESA.APLICATIVO.NENHUMA_ALTERACAO,
        text: '',
        type: 'info',
        timeout: 5000,
    });
};

const validarDados = (empresasId, cores) => ({
    ...cores,
    empresasId,
});

const cadastrarCores = (empresasId: number, cores: Cores) => {
    try {
        const coresParaCadastro = validarDados(empresasId, cores);
        xhr.post(`/empresas/${empresasId}/cores`, coresParaCadastro).then((response) => {
            coresAnterior = cores;
            return response;
        });
    } catch (err) {
        exibirErro(err);
    }
};

const allLoading = applyLoading(arr => Promise.all(arr));

const cadastroAplicativo = (empresasId: number) => {
    const form = getElementoPorId('formulario-aplicativo');
    form.onsubmit = (e) => {
        e.preventDefault();
        const promises = [];

        const cores = getDadosFormularioCores();
        const fileLogo = getFileImagemInput('logo-empresa');
        const fileFundo = getFileImagemInput('imagem-fundo-empresa');

        if (corMudou(cores)) {
            promises.push(cadastrarCores(empresasId, cores));
        }

        if (fileLogo) {
            promises.push(uploads.logo(fileLogo, `/empresas/${empresasId}/logo`));
        }

        if (fileFundo) {
            promises.push(uploads.imagemFundo(fileFundo, `/empresas/${empresasId}/imagem-fundo`));
        }

        if (promises.length) {
            allLoading(promises).then(mensagemSucesso);
            proximaEtapa('urls');
            return;
        }

        mensagemNenhumaAlteracao();
        proximaEtapa('urls');
    };
};

export default cadastroAplicativo;
